export default __webpack_public_path__ + "static/media/bg-image.f1bcdab7.png";